module.exports = __webpack_public_path__ + "media/HaveDoneCounter/Tick-7ec70315.svg";